import { domToReact } from 'html-react-parser';

import { parserOptions } from '@commons/components/RichText';
import type { Template } from '@commons/components/RichText/templates';
import Flex from '@commons/containers/Flex';

import styles from './PromoBox.module.scss';

/**
 * Promo Box Layout CKEditor template.
 *
 * @param nodes - An array of DOM nodes to render.
 *
 * @returns A rendered React component.
 */

const PromoBoxTemplate: Template = ({ nodes }) => (
  <Flex padding="md" className={styles.promoBox}>
    {domToReact(nodes, parserOptions)}
  </Flex>
);

export default PromoBoxTemplate;
